import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../util/api";
import { setLoading } from "../redux/slices/configuracoes/configuracoesSlice";
import { toastError, toastSucess } from "../util/toast";
import { setModalCadastrarGrupoPlanoContaFinanceiro, setModalDeletarGrupoPlanoContaFinanceiro } from "../redux/slices/grupoPlanoContaFinanceiro/grupoPlanoContaFinanceiroSlice";

export const cadastrarGrupoPlanoContaFinanceiro = createAsyncThunk("/GrupoPlanoContaFinanceiro/CadastrarGrupoPlanoContaFinanceiro", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.post("/GrupoPlanoContaFinanceiro/CadastrarGrupoPlanoContaFinanceiro/", payload.value);
    toastSucess("Perfil cadastrado com sucesso");
    dispatch(setModalCadastrarGrupoPlanoContaFinanceiro(false));
    dispatch(setLoading(false));

    dispatch(buscarGrupoPlanoContaFinanceiro(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const buscarGrupoPlanoContaFinanceiro = createAsyncThunk("/GrupoPlanoContaFinanceiro/BuscarGrupoPlanoContaFinanceiro", async (pesquisar: string | null) => {
  try {
    const data = await api.get("/GrupoPlanoContaFinanceiro/BuscarGrupoPlanoContaFinanceiro", { params: { pesquisar: pesquisar } });
    return data.data.data;
  } catch (error: any) {
    throw new Error(error.response.data.Message);
  }
});

export const atualizarGrupoPlanoContaFinanceiro = createAsyncThunk("/GrupoPlanoContaFinanceiro/AtualizarGrupoPlanoContaFinanceiro", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/GrupoPlanoContaFinanceiro/AtualizarGrupoPlanoContaFinanceiro/", payload.value);
    toastSucess("Perfil atualizado com sucesso");
    dispatch(setModalCadastrarGrupoPlanoContaFinanceiro(false));
    dispatch(setLoading(false));

    dispatch(buscarGrupoPlanoContaFinanceiro(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const atualizarGrupoPlanoContaFinanceiroAtivo = createAsyncThunk("/GrupoPlanoContaFinanceiro/AtualizarGrupoPlanoContaFinanceiroAtivo", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.put("/GrupoPlanoContaFinanceiro/AtualizarGrupoPlanoContaFinanceiroAtivo?id=" + payload.value.id + "&ativo=" + payload.value.ativo);
    toastSucess("Status do perfil atualizado com sucesso");
    dispatch(setLoading(false));

    dispatch(buscarGrupoPlanoContaFinanceiro(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});

export const deletarGrupoPlanoContaFinanceiro = createAsyncThunk("/GrupoPlanoContaFinanceiro/DeletarGrupoPlanoContaFinanceiro", async (payload: any, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    await api.delete("/GrupoPlanoContaFinanceiro/DeletarGrupoPlanoContaFinanceiro/?id=" + payload.value);
    toastSucess("Perfil removido com sucesso");
    dispatch(setModalDeletarGrupoPlanoContaFinanceiro(false));
    dispatch(setLoading(false));

    dispatch(buscarGrupoPlanoContaFinanceiro(payload.busca));
  } catch (error: any) {
    dispatch(setLoading(false));
    toastError(error.response.data.Message);
  }
});
